/**
 * Fotoğrafı yüklemeden önce küçültür.
 *
 * Telefon kamerası 3–8 MB'lık dosyalar üretiyor; olduğu gibi gönderilseydi
 * sahadaki mobil bağlantıda her kayıt uzun sürer, sunucuda da gereksiz yer
 * kaplardı. Ürün kodunu ve parçayı tanımaya 1600 piksel fazlasıyla yetiyor.
 *
 * Küçültme tarayıcıda yapılıyor: sunucuda yapmak için görselin önce tam
 * boyutuyla yüklenmesi gerekirdi, yani kazanılacak şey kaybedilirdi.
 */

const EN_UZUN_KENAR = 1600;
const KALITE = 0.82;

export interface KucukGorsel {
  /** `data:image/jpeg;base64,...` */
  dataUri: string;
  genislik: number;
  yukseklik: number;
  /** Yaklaşık bayt — base64 çözülmüş hali. */
  bayt: number;
}

export async function gorseliKucult(dosya: Blob): Promise<KucukGorsel> {
  const resim = await dosyayiYukle(dosya);

  const oran = Math.min(1, EN_UZUN_KENAR / Math.max(resim.width, resim.height));
  const genislik = Math.round(resim.width * oran);
  const yukseklik = Math.round(resim.height * oran);

  const tuval = document.createElement('canvas');
  tuval.width = genislik;
  tuval.height = yukseklik;

  const ctx = tuval.getContext('2d');
  if (!ctx) throw new Error('Görsel işlenemedi');

  ctx.drawImage(resim, 0, 0, genislik, yukseklik);
  kaynagiBirak(resim);

  const dataUri = tuval.toDataURL('image/jpeg', KALITE);
  const base64 = dataUri.slice(dataUri.indexOf(',') + 1);

  return {
    dataUri,
    genislik,
    yukseklik,
    bayt: Math.round((base64.length * 3) / 4),
  };
}

type Kaynak = ImageBitmap | HTMLImageElement;

async function dosyayiYukle(dosya: Blob): Promise<Kaynak> {
  // createImageBitmap EXIF dönüşünü kendisi uygular ve daha az bellek harcar.
  if ('createImageBitmap' in window) {
    try {
      return await createImageBitmap(dosya);
    } catch {
      // Eski tarayıcılarda aşağıdaki yola düşülür.
    }
  }

  const url = URL.createObjectURL(dosya);
  try {
    return await new Promise<HTMLImageElement>((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error('Fotoğraf okunamadı'));
      img.src = url;
    });
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 10_000);
  }
}

function kaynagiBirak(kaynak: Kaynak): void {
  if ('close' in kaynak) kaynak.close();
}
